/* The contact form's rules, shared by the form and the API route so the
 * browser and the server always agree on what a valid message is. */

export const CONTACT_TOPICS = ["New project", "Freelance role", "Talk or workshop", "Just saying hi"] as const

export const CONTACT_LIMITS = {
    name: 100,
    email: 200,
    messageMin: 10,
    message: 2000
} as const

export type ContactField = 'name' | 'email' | 'topic' | 'message'

export type ContactInput = Record<ContactField, string>

export type ContactErrors = Partial<Record<ContactField, string>>

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

const text = (value: unknown): string => (typeof value === 'string' ? value.trim() : '')

export const cleanContact = (raw: Record<string, unknown>): ContactInput => ({
    name: text(raw.name),
    email: text(raw.email),
    topic: text(raw.topic),
    message: text(raw.message)
})

export const validateContact = (input: ContactInput): ContactErrors => {
    const errors: ContactErrors = {}

    if (!input.name) errors.name = "Tell me your name."
    else if (input.name.length > CONTACT_LIMITS.name) errors.name = "Keep your name under 100 characters."

    if (!input.email) errors.email = "Add your email so I can reply."
    else if (input.email.length > CONTACT_LIMITS.email || !EMAIL_PATTERN.test(input.email)) errors.email = "That email doesn't look quite right."

    if (!(CONTACT_TOPICS as readonly string[]).includes(input.topic)) errors.topic = "Pick what your message is about."

    if (input.message.length < CONTACT_LIMITS.messageMin) errors.message = "Write a little more, at least 10 characters."
    else if (input.message.length > CONTACT_LIMITS.message) errors.message = "Keep it under 2,000 characters."

    return errors
}
